import { NctsError } from '../../../../shared/ncts/types'
import { FieldError } from '../../../../shared/rhf/applyFormFieldErrors'

const CI_INDEX_RE = /^houseConsignment[.[](\d+)\]?\.consignmentItem[.[](\d+)/
const CI_PATH_PREFIX_RE = /^houseConsignment[.[]\d+\]?\.consignmentItem[.[]\d+\]?\.?/

export function getNctsErrorConsignmentItemIndices(error: NctsError): { hcIndex: number; ciIndex: number } | null {
  const match = CI_INDEX_RE.exec(error.path ?? '')
  if (!match) return null
  return { hcIndex: Number(match[1]), ciIndex: Number(match[2]) }
}

export function belongsToConsignmentItem(error: NctsError, hcIndex: number, ciIndex: number): boolean {
  const idx = getNctsErrorConsignmentItemIndices(error)
  return idx != null && idx.hcIndex === hcIndex && idx.ciIndex === ciIndex
}

export function mapNctsErrorsToConsignmentItemFieldErrors(
  errors: NctsError[],
  hcIndex: number,
  ciIndex: number,
): FieldError[] {
  return errors
    .filter((err) => belongsToConsignmentItem(err, hcIndex, ciIndex))
    .map((err) => ({
      path: (err.path ?? '').replace(CI_PATH_PREFIX_RE, ''),
      message: err.message,
    }))
}
